import VideosService from "@/services/VideosService";

import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

export const getVideos = createAsyncThunk(
  "videos",
  async (params, {rejectWithValue}) => {
    try {
      const response = await VideosService.getVideos(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  data: [],
  sort: {value: "created_at", direction: "desc"},
  search: "",
  page: 1,
  size: 5,
  totalData: null,
  totalPages: 1,
  selectedData: null,
  errors: null,
  error: "",
  status: "",
};

const videosSlice = createSlice({
  name: "videos",
  initialState,
  reducers: {
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    setData(state, action) {
      state.data = action.payload;
    },
    setSelectedData(state, action) {
      state.selectedData = action.payload;
    },
    setSearch(state, action) {
      state.search = action.payload;
      state.page = 1;
    },
    setPage(state, action) {
      state.page = Math.max(1, action.payload);
    },
    setSize(state, action) {
      state.size = action.payload;
    },
    setSort(state, action) {
      state.sort = action.payload;
    },
    setTotalPages(state, action) {
      state.totalPages = action.payload;
    },
    setTotalData(state, action) {
      state.totalData = action.payload;
    },
    clearTable() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVideos.pending, (state) => {
        pendingState(state);
      })
      .addCase(getVideos.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.totalPages = action.payload.total
          ? Math.ceil(action.payload.total / state.size)
          : state.totalPages;
        fulfilledState(state);
      })
      .addCase(getVideos.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {
  setPage,
  setSort,
  clearTable,
  setTotalPages,
  setErrors,
  setError,
  setSize,
  setStatus,
  setSelectedData,
  setData,
  setSearch,
  setTotalData,
} = videosSlice.actions;
export default videosSlice.reducer;
